<div>
  <span [className]="badgeClass">
    {{badgeContent | translate}}
  </span>
</div>
